(() => {
  const dialog = document.getElementById('njt-fitment-reminder');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const labels = JSON.parse(dialog.querySelector('[data-njt-fitment-labels]').textContent);
  const root = window.Shopify?.routes?.root || '/';
  const vehicleKey = 'filter.p.m.organizer.car_models';
  const storageKey = 'gta-global-vehicle-filter';
  const make = dialog.querySelector('#njt-fitment-make');
  const model = dialog.querySelector('#njt-fitment-model');
  const vehicle = dialog.querySelector('#njt-fitment-vehicle');
  const check = dialog.querySelector('[data-njt-fitment-check]');
  const next = dialog.querySelector('[data-njt-fitment-continue]');
  const retry = dialog.querySelector('[data-njt-fitment-retry]');
  const status = dialog.querySelector('[data-njt-fitment-status]');
  const results = dialog.querySelector('[data-njt-fitment-results]');
  let pending = null;
  let accepted = false;
  let options = [];
  let generation = 0;
  let busy = false;
  let needsReview = false;
  const normalize = value => typeof value === 'string' ? value.trim().toLowerCase() : '';
  const valid = value => normalize(value) !== '' && normalize(value) !== 'vehicle';
  const hasSelectedVehicle = () => {
    if (valid(new URLSearchParams(location.search).get(vehicleKey))) return true;
    try { return valid(JSON.parse(localStorage.getItem(storageKey) || 'null')?.vehicleName); }
    catch (_) { return false; }
  };
  const endpoint = path => {
    const url = new URL(root + path, location.origin);
    const current = new URLSearchParams(location.search);
    for (const key of ['preview_theme_id', '_fd', 'pb']) if (current.has(key)) url.searchParams.set(key, current.get(key));
    return url;
  };
  async function request(url, init = {}) {
    const response = await fetch(url, {...init, credentials:'same-origin', cache:'no-store', signal:AbortSignal.timeout(8000)});
    if (!response.ok) throw new Error('Request failed');
    return response;
  }
  const setBusy = value => {
    busy = value;
    next.disabled = value;
    check.disabled = value || !vehicle.value;
    make.disabled = value || !options.length;
    model.disabled = value || !make.value;
    vehicle.disabled = value || !model.value;
    dialog.setAttribute('aria-busy', String(value));
  };
  const reset = (select, label, choices) => {
    select.replaceChildren(new Option(label, ''), ...choices);
    select.value = '';
  };
  const clearResults = () => {
    results.querySelectorAll('[data-njt-fitment-badge]').forEach(badge => {
      badge.textContent = labels.select_first;
      delete badge.dataset.result;
    });
    results.querySelectorAll('[data-njt-fitment-detail]').forEach(detail => {detail.textContent = '';});
    status.textContent = '';
  };
  make.addEventListener('change', () => {
    const models = [...new Set(options.filter(option => option.dataset.make === make.value).map(option => option.dataset.model))].sort();
    reset(model, labels.select_model, models.map(name => new Option(name, name)));
    reset(vehicle, labels.select_vehicle, []);
    clearResults(); setBusy(false);
  });
  model.addEventListener('change', () => {
    reset(vehicle, labels.select_vehicle, options.filter(option => option.dataset.make === make.value && option.dataset.model === model.value).map(option => option.cloneNode(true)));
    clearResults(); setBusy(false);
  });
  vehicle.addEventListener('change', () => { clearResults(); setBusy(false); });
  async function load() {
    const id = ++generation;
    clearResults(); results.replaceChildren(); retry.hidden = true;
    options = [];
    reset(make, labels.select_make, []); reset(model, labels.select_model, []); reset(vehicle, labels.select_vehicle, []);
    setBusy(true); status.textContent = labels.loading;
    try {
      const url = endpoint('cart'); url.searchParams.set('section_id', 'njt-cart-fitment');
      const response = await request(url);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (id !== generation || !dialog.open) return;
      const source = doc.querySelector('[data-njt-cart-fitment]');
      const template = source?.querySelector('[data-njt-fitment-vehicles]');
      const items = source?.querySelector('.njt-fitment-items');
      if (!template || !items) throw new Error('Fitment data unavailable');
      options = [...template.content.querySelectorAll('option')].filter(option => valid(option.value) && option.dataset.make && option.dataset.model);
      const makes = [...new Set(options.map(option => option.dataset.make))].sort();
      reset(make, labels.select_make, makes.map(name => new Option(name, name)));
      results.append(document.importNode(items, true));
      status.textContent = items.children.length ? '' : labels.empty;
      needsReview = false;
      if (!options.length) {status.textContent = labels.load_error; retry.hidden = false;}
    } catch (_) {
      if (id !== generation || !dialog.open) return;
      status.textContent = labels.load_error; retry.hidden = false;
    } finally {
      if (id === generation && dialog.open) setBusy(false);
    }
  }
  function showResults(selected) {
    let warning = false;
    results.querySelectorAll('[data-njt-fitment-item]').forEach(item => {
      let entries = null;
      try { entries = JSON.parse(item.dataset.vehicles); } catch (_) {}
      const list = Array.isArray(entries) ? entries.filter(entry => typeof entry === 'string' && entry.trim()) : [];
      const unknown = !list.length && item.dataset.universal !== 'true';
      const fits = item.dataset.universal === 'true' || list.some(entry => normalize(entry) === normalize(selected.value) || normalize(entry) === 'all vehicles');
      const result = unknown ? 'unknown' : fits ? 'fits' : 'no';
      const badge = item.querySelector('[data-njt-fitment-badge]');
      badge.dataset.result = result;
      badge.textContent = (result === 'fits' ? '✓ ' : '⚠ ') + labels[result];
      item.querySelector('[data-njt-fitment-detail]').textContent = unknown ? labels.unknown_note : item.dataset.sizeCheck === 'true' ? labels.size_note : '';
      warning ||= result !== 'fits';
    });
    return labels.checked.replace('{vehicle}', selected.textContent) + (warning ? ' ' + labels.summary_warning : '');
  }
  check.addEventListener('click', async () => {
    const selected = vehicle.selectedOptions[0];
    if (busy || !selected?.value) return;
    const id = generation;
    setBusy(true); status.textContent = labels.checking;
    const chosen = {vehicleName:selected.value, vehicleMake:make.value, vehicleModel:model.value, vehicleTitleOverwrite:selected.dataset.title || selected.textContent, vehicleCollectionHandle:selected.dataset.handle || ''};
    const summary = showResults(selected);
    try {
      await request(endpoint('cart/update.js'), {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({attributes:{'Vehicle Filter':chosen.vehicleTitleOverwrite}})});
      if (id !== generation || !dialog.open) return;
      try {localStorage.setItem(storageKey, JSON.stringify(chosen));} catch (_) {}
      document.dispatchEvent(new CustomEvent('njt:vehicle-state', {detail:chosen}));
      status.textContent = summary;
    } catch (_) {
      if (id === generation && dialog.open) status.textContent = summary + ' ' + labels.save_error;
    } finally {
      if (id === generation && dialog.open) setBusy(false);
    }
  });
  const invalidate = () => {
    accepted = false;
    if (dialog.open) {needsReview = true; status.textContent = labels.changed;}
  };
  document.addEventListener('change', event => {
    if (event.target.closest('cart-items,cart-drawer-items,#cart,#CartDrawer-Form')) invalidate();
  }, true);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, invalidate);
  document.addEventListener('submit', event => {
    const form = event.target, button = event.submitter;
    if (!['cart', 'CartDrawer-Form'].includes(form.id) || button?.name !== 'checkout' || accepted || hasSelectedVehicle()) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (dialog.open) return;
    pending = {formId:form.id, buttonId:button.id, button};
    dialog.showModal(); load();
  }, true);
  retry.addEventListener('click', load);
  dialog.querySelector('[data-njt-fitment-review]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    generation++;
    pending?.button.focus({preventScroll:true});
    pending = null;
  });
  next.addEventListener('click', async () => {
    if (!pending || busy) return;
    if (needsReview) {await load(); status.textContent = labels.changed; return;}
    const form = document.getElementById(pending.formId);
    const button = document.getElementById(pending.buttonId) || pending.button;
    if (!form || !button.isConnected || button.disabled) { dialog.close(); return; }
    accepted = true; pending = null; dialog.close(); form.requestSubmit(button);
  });
})();
